import * as React from 'react';
import './style.css';

import { RefSet } from 'src/util';

import App from 'src/state/App';
import Room from 'src/state/Room';
import RoomPage from 'src/state/RoomPage';
import Player from 'src/state/Player';

const PlayerSelector: React.SFC<{
  store: App.Store,
  room: Room,
  page: RoomPage,
  playerSide: 0 | 1,
}> = (
  ({store, room, page, playerSide}) => {
    const playerRef = Player.Pair.Current(page.selectedPlayers, playerSide);

    const player = (
      playerRef &&
      RefSet.resolve(room.entities.players, playerRef)
    );

    const opponentRef = Player.Pair.Opponent(page.selectedPlayers, playerSide);

    const existingChoices = (
      RefSet.size(room.entities.players) -
      (opponentRef ? 1 : 0)
    );

    const text = (player && player.name) || (
      (opponentRef ? 'Select Opponent' : 'Select Player')
    );

    const style = !player ? { fontStyle: 'italic' } : {};

    const onClick = () => RoomPage.showDialog(
      {
        type: 'PlayerSelector',
        data: {
          selection: (
            player ? { type: 'existing', data: player } :
            existingChoices > 0 ? { type: 'none' } :
            { type: 'new' }
          ),
          newOptionText: '',
        },
        metadata: {
          side: playerSide,
        },
      },
      store.dispatchCurrentRoomPage,
    );

    return (
      <div
        className="player-selector"
        onClick={onClick}
        style={style}
      >
        {text}
      </div>
    );
  }
);

export default PlayerSelector;



// WEBPACK FOOTER //
// ./src/ui/PlayerSelector/index.tsx